module.exports = __webpack_public_path__ + "static/media/save.5d9a4a60.svg";